export const InvoiceOrder = (
    date,
    currency,
    hotLine,
    discount,
    total,
    clientInfo,
    invoiceNumber,
    cashier,
    infoSystem,
    invoiceEnd,
    isDesktopApp,
    ...data
) => {

    let RoR = '';

    if (invoiceEnd.rules.decision === 'replace') {
        RoR = "الأستبدال";
    } else if (invoiceEnd.rules.decision === 'return') {
        RoR = "استرجاع";
    } else {
        RoR = "استبدال او استرجاع";
    }

    const rows = (data?.[0] || [])
    .map(item => {
        const discountValue =
            item.discount?.discountType === "fixed"
                ? parseFloat(item.discount?.discountValue || 0).toFixed(2)
                : `${parseFloat(item.discount?.discountValue || 0).toFixed(2)}%`;

        return `
            <h4>${item.name} - ${item.barcode}</h4>
            <ul class="flex">
                <li>${item.quantity}</li>
                <li>${discountValue}</li>
                <li>${parseFloat(item.price || 0).toFixed(2)}</li>
                <li>${parseFloat(item.amount || 0).toFixed(2)}</li>
            </ul>
        `;
    })
    .join('');

    const printPage = window.open('', '_blank');

    if (!printPage) {
        console.error("Popup blocked or print window failed");
        return;
    }

    const doc = printPage.document;

    doc.open();

    doc.write(`
        <!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Invoice</title>

<style>
/* Your existing styles here (unchanged) */
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.line {
    border-bottom: 1px dashed #000;
}

.head {
    font-size: 55%;
}

@page {
    size: 80mm auto;
    margin: 0;
}

html, body {
    width: 80mm;
    margin: 0;
    padding: 0;
    font-family: monospace;
}

@media print {
    html, body {
        width: 80mm;
        margin: 0 !important;
        padding: 0 !important;
    }

    body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .end {
        height: auto !important;
    }
}

.qr { margin: 10px 0; }
.qr img { width: 90px; }

.header { direction: rtl; }

.header h1 { font-size: 15px; }
.header h2 { font-size: 12px; }

.info-client p {
    margin: 5px 0;
    font-size: 12px;
}

ul { list-style: none; }

.total {
    margin-left: 5px;
    margin-top: 5px;
    font-size: 13px;
}

.footer {
    text-align: center;
    padding: 10px;
}

.footer p {
    font-size: 10px;
    width: 80%;
    margin: 0 auto;
}

.calcTotal p {
    font-size: 10px;
    margin: 5px 0;
}

.calcTotal .total-invoice {
    font-size: 15px;
}

.info-device p {
    direction: rtl;
}

.end {
    height: auto;
}
</style>

</head>

<body>

<div class="head footer">
    <h1>${infoSystem.branch}</h1>
    <h3>الخط الساخن <span>${hotLine}</span></h3>
</div>

${
clientInfo?.phone_number && clientInfo?.address && clientInfo?.mode === "delivery"
? `
<div class="info-client">
    <h4 class="header">delivery</h4>
    <div class="flex">
        <div class="info">
            <p>${clientInfo.client_name}</p>
            <p>${clientInfo.address} ${clientInfo?.details?.specialMark || ""}</p>
            <p>الدور: ${clientInfo?.details?.floor || ""}</p>
            <p>شقة: ${clientInfo?.details?.door || ""}</p>
        </div>
        <div class="info">
            <p>${clientInfo.phone_number}</p>
        </div>
    </div>
</div>
`
: ""
}

<div class="header line">
    <h2>رقم الطلب <span>#${invoiceNumber}</span></h2>
</div>

<div class="body">

<ul class="line flex">
    <li>Qty</li>
    <li>الخصم</li>
    <li>السعر</li>
    <li>الأجمالي</li>
</ul>

<div>
    ${rows}
</div>

<div class="line"></div>

<div class="calcTotal flex line">
    <div class="details">
        <p>الخصم على الفاتورة: <b>${Number(discount || 0).toFixed(2)} ${currency}</b></p>

        ${
        clientInfo?.phone_number && clientInfo?.mode === "delivery"
        ? `<p>رسوم التوصيل: <b>${Number(clientInfo?.payment || 0).toFixed(2)} ${currency}</b></p>`
        : ""
        }
    </div>

    <div class="total">
        <p class="total-invoice">الأجمالي: <b>${total} ${currency}</b></p>
    </div>
</div>

<div class="system-info">
    <div class="flex">
        <p>الكاشير ${cashier.name}</p>
        <p>${date}</p>
    </div>

    <div class="info-device flex line">
        <p>store: <span>${infoSystem.storeNumber}</span></p>
        <p>PoS: <span>${infoSystem.posStorageId}</span></p>
        <p>user: <span>${cashier.id}</span></p>
    </div>
</div>

</div>

<div class="footer end">
    <p>شكرا للتسوق في ${infoSystem.branch}</p>
    <p>${invoiceEnd.closing}</p>
    <p>الخط الساخن <span>${hotLine}</span></p>
    <p>يمكن ${RoR} المنتج خلال ${invoiceEnd.rules.time} ساعة</p>
    <p>https://zone.com/</p>
</div>

<div style="display:block; height: 50mm;"></div>
<p>.</p>

</body>
</html>
    `);

    doc.close();

    // ✅ الحل النهائي
    if(isDesktopApp) {
        const html = doc.documentElement.outerHTML;
        window.electronAPI.printInvoice(html);        
        setTimeout(() => {
            printPage.close();
        }, 500);
    }
    else {
        printPage.onafterprint = () => {
            printPage.close();
        };
        
        printPage.print();
    }

    return printPage;
};